export default {
    implementos: [],
    implemento: {}
}